import React from 'react';
import JusfyPayFrame from './JusfyPayFrame';

export const JusfyPayCharges: React.FC = () => <JusfyPayFrame path="/charges" />;
export const JusfyPayWallet: React.FC = () => <JusfyPayFrame path="/wallet" />;
export const JusfyPayProfile: React.FC = () => <JusfyPayFrame path="/profile" />;
export const JusfyPayNewCharge: React.FC = () => <JusfyPayFrame path="/charges" newPaymentLink />;
export const JusfyPaySimulator: React.FC = () => <JusfyPayFrame path="/fee-simulator" />;